import { atom } from 'jotai/index';
import { fetchLookups } from '~/service/fetchLookups';
export const lookupsAtom = atom(async () => fetchLookups());
